export default __webpack_public_path__ + "static/media/Icons_7.0fec6e8c.svg";